import "./Main.scss";

export default function Main() {
  return <h1 className="main">Main</h1>;
}
